function Icon() {
  return (
    <path d="M1010.845 949.656l-230.734-230.943c62.225-75.798 99.393-172.894 99.393-278.551 0-242.845-196.907-439.752-439.752-439.752s-439.752 196.907-439.752 439.752 196.907 439.752 439.752 439.752c106.075 0 203.38-37.586 279.387-100.228l230.734 230.734c26.936 24.639 52.202 8.77 60.972 0 17.54-17.331 17.54-43.432 0-60.763zM85.821 440.161c0-195.445 158.486-353.931 353.931-353.931s354.14 158.486 354.14 353.931-158.486 353.931-353.931 353.931-354.14-158.486-354.14-353.931z"></path>
  )
}

export default Icon
